import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Owner-only. The bot token is stored server-side and only ever comes back
// masked — `bot_token_masked` is for display, never for re-submitting.
const secureAuthService = {
  getBot: async () => {
    const response = await api.get(API_ENDPOINTS.SECURE_AUTH.BOT)
    return response.data
  },
  updateBot: async (data) => {
    const response = await api.put(API_ENDPOINTS.SECURE_AUTH.BOT, data)
    return response.data
  },

  // ── The logged-in owner/staff's OWN secure auth ────────────────────────────
  // Same four steps the player page uses, against the admin mount.
  selfVerifyPassword: async (password) => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_VERIFY_PASSWORD, { password })
    return response.data
  },
  selfGetLinkCode: async () => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_GENERATE_LINK_CODE)
    return response.data
  },
  selfSendDisableCode: async () => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_SEND_DISABLE_CODE)
    return response.data
  },
  selfDisable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_DISABLE, { otp })
    return response.data
  },

  // ── Google Authenticator (TOTP) ───────────────────────────────────────────
  selfGoogleSetup: async (password) => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_GOOGLE_SETUP, { password })
    return response.data
  },
  selfGoogleEnable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_GOOGLE_ENABLE, { otp })
    return response.data
  },
  selfGoogleDisable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_GOOGLE_DISABLE, { otp })
    return response.data
  },

  // ── Secure Auth Verification App (Android) ────────────────────────────────
  // pair → { code, expiresIn }. The PHONE redeems the code (with username +
  // password), which enables secure auth and ends this session by itself.
  selfAndroidPair: async () => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_ANDROID_PAIR, {})
    return response.data
  },
  selfAndroidDisable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.SECURE_AUTH.SELF_ANDROID_DISABLE, { otp })
    return response.data
  },
}

export default secureAuthService
